import React, {Component} from 'react';
import {Modal, Alert, Menu, Dropdown, message, Tabs, Avatar, Row, Col} from 'antd';
import {createHistory} from 'react-router'
import './style.scss';
import {setStore, getStore, removeStore} from '@/utils/storage';
import {API} from '@/api';
import eventProxy from 'react-eventProxy'
import WXLogin from '@/assets/icon/wx_login.png'
import {toRegist} from '@/utils/string'
import cookie from "react-cookies";
import domain from '@/utils/domain';
import WXLogin_1 from '@/components/WxLogin/index'
import success from '../../../public/success.html';
import {UserOutlined} from '@ant-design/icons';

const {TabPane} = Tabs;

export default class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userlogin: false,
      error: '',
      usecookie: 0,
      username: '',
      password: '',
      user: {
        id: cookie.load('userid'),
        nickname: cookie.load('nickname'),
        avatar: cookie.load('avatar'),
        token: cookie.load('token')
      },
      author: {
        id: cookie.load('authorid'),
        nickname: cookie.load('authornickname'),
        token: cookie.load('authortoken')
      },
      isShowUserLoginModal: false,
      isShowIframe: false,
      isShowType: 'user'
    }
  }

  componentDidMount() {
    var pathname = window.location.pathname;
    // if (pathname.indexOf('/author/') !== -1) {
      //作者模式
      const {author} = this.state
      if (author.id > 0 && author.token !== '') {
        this.setState({
          isShowType: 'author'
        });
      }
    // }
    eventProxy.on('isShowUserLoginModal', (isShowUserLoginModal) => {
      this.setState({
        isShowUserLoginModal
      });
    });


  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isShowUserLoginModal: nextProps.isShowUserLoginModal
    })
  }

  componentDidUpdate() {
    let that = this
    if (that.state.toastShow) {
      setTimeout(function () {
        that.setState({toastShow: false})
      }, 3000);
    } else {
      return false
    }
  }

  dologin() {
    this.setState({
      error: ''
    })
    let username = this.state.username
    let password = this.state.password
    let usecookie = this.state.usecookie
    if (username == '' || password == '') {
      this.setState({
        error: '请输入用户名、密码'
      })
      return false
    }
    API.userLogin({
      username: username,
      password: password,
      usecookie: usecookie
    }).then((response) => {
      const {code, data, msg, time} = response.data;
      var maxAge = 3600 * 24 * 365;
      if (code === 1) {
        if (domain == 'localhost') {
          cookie.save('userid', data.userid, {path: '/', maxAge: maxAge})
          cookie.save('nickname', data.username, {path: '/', maxAge: maxAge})
          cookie.save('avatar', data.avatar, {path: '/', maxAge: maxAge})
          cookie.save('token', data.token, {path: '/', maxAge: maxAge})
        } else {
          cookie.save('userid', data.userid, {path: '/', domain: domain, maxAge: maxAge})
          cookie.save('nickname', data.nickname, {path: '/', domain: domain, maxAge: maxAge})
          cookie.save('avatar', data.avatar, {path: '/', domain: domain, maxAge: maxAge})
          cookie.save('token', data.token, {path: '/', domain: domain, maxAge: maxAge})
        }

        message.success('登录成功！').then(() => {
          location.href = '/'
        })
      }
      else {
        message.error(msg);
      }
    })
  }

  changeUsername(e) {
    this.setState({
      username: e.target.value,
    })
  }

  changePassword(e) {
    this.setState({
      password: e.target.value,
    })
  }

  _hide() {
    return this.props.callback({type: 'hide', value: false})
  }

  onMenuClick = (e) => {
    switch (e.key) {
      case '1':
        if (domain == 'localhost') {
          cookie.remove('avatar', {path: '/'})
          cookie.remove('token', {path: '/'})
          cookie.remove('authorid', {path: '/'})
          cookie.remove('userid', {path: '/'})
          cookie.remove('nickname', {path: '/'})
        } else {
          cookie.remove('avatar', {path: '/'})
          cookie.remove('token', {path: '/'})
          cookie.remove('authorid', {path: '/'})
          cookie.remove('userid', {path: '/'})
          cookie.remove('nickname', {path: '/'})
          cookie.remove('avatar', {path: '/', domain: '.mixs.cn'})
          cookie.remove('token', {path: '/', domain: '.mixs.cn'})
          cookie.remove('authorid', {path: '/', domain: '.mixs.cn'})
          cookie.remove('userid', {path: '/', domain: '.mixs.cn'})
          cookie.remove('nickname', {path: '/', domain: '.mixs.cn'})
        }
        message.success('退出成功！').then(() => {
          location.href = '/'
        })
        break;
      case '2':
        this.setState({
          isShowUserLoginModal: !this.state.isShowUserLoginModal
        })
        break;
      case '3':
        toRegist();
        break;
    }
  }

  showLoginModal() {
    this.setState({
      isShowUserLoginModal: !this.state.isShowUserLoginModal
    })
  }

  closeUserLoginModal() {
    this.setState({
      isShowUserLoginModal: false
    })
  }

  wxLogin(param) {
    API.wxScanCode(param).then((response) => {
      console.log(response)
      const {code, data, msg, time} = response;
      var maxAge = 3600 * 24 * 365;
      if (code == 1) {
        if (domain == 'localhost') {
          cookie.save('userid', data.user_id, {path: '/', maxAge: maxAge})
          cookie.save('nickname', data.nickname, {path: '/', maxAge: maxAge})
          cookie.save('avatar', data.avatar, {path: '/', maxAge: maxAge})
          cookie.save('token', data.token, {path: '/', maxAge: maxAge})
        } else {
          cookie.save('userid', data.user_id, {path: '/', domain: domain, maxAge: maxAge})
          cookie.save('nickname', data.nickname, {path: '/', domain: domain, maxAge: maxAge})
          cookie.save('avatar', data.avatar, {path: '/', domain: domain, maxAge: maxAge})
          cookie.save('token', data.token, {path: '/', domain: domain, maxAge: maxAge})
        }
        location.href = '/'
      }
      else {
        this.setState({
          error: response.returnmessage
        })
      }
    })
  }

  callback(key) {
    console.log(key);
  }


  render() {
    const {error, isShowUserLoginModal, isShowIframe, user, author, isShowType} = this.state
    const {onMenuClick, wxLogin, callback} = this
    const logmenu = (
      <Menu onClick={onMenuClick}>
        <Menu.Item key="1">
          退出
        </Menu.Item>
      </Menu>
    );

    const logmenu1 = (
      <Menu onClick={onMenuClick}>
        <Menu.Item key="2">
          登录
        </Menu.Item>
      </Menu>
    );

    return (
      <div>
        <div>
          {isShowType === 'author' ? (<Row style={{height:'100%',width:'110px'}}>
              <Col span={24} className={`margin-t-10`}><div  className={`text-align-c author-nickname-wrapper`}><div className={`author-nickname`}>{author.nickname}</div></div></Col>
            </Row>)
            :
            (user.token ?
              <Dropdown overlay={logmenu} placement="bottomCenter">
                <Row style={{height:'100%',width:'110px'}}>
                  <Col span={24} className={`margin-t-10`}><div  className={`text-align-c author-nickname-wrapper`}><div className={`author-nickname`}><a href="/my/account">{user.nickname}</a></div></div></Col>
                </Row>
              </Dropdown>
              :
              (<Dropdown overlay={logmenu1} placement="bottomCenter">
                <Row style={{height:'100%',width:'110px'}}>
                  <Col span={24} className={`margin-t-10`}><div  className={`text-align-c author-nickname-wrapper`}><div className={`author-nickname`} onClick={this.showLoginModal.bind(this)}>登录</div></div></Col>
                </Row>
              </Dropdown>))
          }
        </div>

        <Modal
          mask={true}
          closable={false}
          title={null}
          visible={isShowUserLoginModal}
          footer={null}
          width={458}
        >

          <div class="box-wrap">
            <a class="close" onClick={this.closeUserLoginModal.bind(this)}><em class="fa fa-close"></em></a>

            <Tabs defaultActiveKey="1" onChange={callback}>
              <TabPane tab="蜜阅登录" key="1">
                <div className="login-wrap pull-l">
                  <div className="login-switch-wrap">
                    <div className="login-tab-wrap">
                      <div className="login-box">
                        <div className="web-login-wrap">
                          <div className="login-input-mode">
                            <div className="login-mode input-mode show">
                              {error != '' ?
                                <Alert message={error} type="error"/>
                                : ''}
                              <dl>
                                <dd><em className="fa fa-username"></em><input type="text"
                                                                               placeholder="手机/邮箱/用户名"
                                                                               defaultValue={''}
                                                                               onChange={this.changeUsername.bind(this)}/>
                                </dd>
                                <dd><em className="fa fa-password"></em><input type="password" placeholder="密码"
                                                                               defaultValue={''}
                                                                               onChange={this.changePassword.bind(this)}/>
                                </dd>
                              </dl>

                              <div className="login-common-wrap">
                                <a className="red-btn go-login btnLogin login-button" onClick={this.dologin.bind(this)}>登
                                  录</a>
                              </div>
                            </div>

                          </div>

                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </TabPane>
            </Tabs>
          </div>
        </Modal>
      </div>
    )
  }
}
